import { MeterKind } from '@enmon/commons/lib/enmon';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const METER_KIND_TRANSLATED = defineMessages<MeterKind>({
  [MeterKind.Physical]: { id: 'app.common.meter.kind.Physical' },
  [MeterKind.Virtual]: { id: 'app.common.meter.kind.Virtual' },
});
